// This module provides API call methods for Sephora Commerce
// Beauty Insider APIs:
// https://jira.sephora.com/wiki/display/ILLUMINATE/Beauty+Insider+APIs

const getBiPoints = require('./getBiPoints');
const getBiDigitalCardNumber = require('./getBiDigitalCardNumber');
const getBiAccountHistory = require('./getBiAccountHistory');
const createBiAccount = require('./createBiAccount');
const updateBiAccount = require('./updateBiAccount');
const unlinkBiAccount = require('./unlinkBiAccount');
const getPurchaseHistory = require('./getPurchaseHistory');
const addBiRewardsToCart = require('./addBiRewardsToCart');
const removeBiRewardFromBasket = require('./removeBiRewardFromBasket');
const getBiRewards = require('./getBiRewards');
const {
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf
} = require('./getBiRewardsGroup');
const getClientSummary = require('./getClientSummary');

module.exports = {
    getBiPoints,
    getBiDigitalCardNumber,
    getBiAccountHistory,
    createBiAccount,
    updateBiAccount,
    unlinkBiAccount,
    addBiRewardsToCart,
    removeBiRewardFromBasket,
    getPurchaseHistory,
    getBiRewardsGroupForCheckout,
    getBiRewardsGroupForProfile,
    getBiRewardsGroupForSnapshot,
    getBiRewardsGroupForOrderConf,
    getBiRewards,
    getClientSummary
};
